module.exports = __webpack_public_path__ + "img/1-2.4033efe5.jpg";